import {Col, Row} from "react-bootstrap";
import React from "react";
import Back from "../layout/template/back";

const RegistrationSent = () => {

        return (
            <>
                <Row>
                    <Col lg={6}>
                        <Row>
                            <Col>
                                <Back />
                            </Col>
                        </Row>

                        <Row className={'mt-5 mb-2'}>
                            <Col>
                                <h2 className={'fw-bold'}>Registrazione nuovo account</h2>
                            </Col>
                        </Row>

                        <Row className={'mb-5'}>
                            <Col>
                                <p>
                                    Abbiamo inviato la conferma di registrazione al tuo indirizzo e-mail. <br/>
                                    Controlla la tua posta in arrivo e conferma la registrazione.
                                </p>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </>

        );
}

export default RegistrationSent;
